import axios from "axios";
import { useQueries, UseQueryResult } from "react-query";
import { toast } from "react-toastify";
import { minutesAsMilliSeconds } from "../../../Utils/time";
import {
  branchUrls,
  edcUrls,
  odcUrls,
  plantUrls,
  supplierUrls,
} from "../../../URL/ApplicationUrls";
import { SelectionListItem } from "../../SelectionListItem";

export const useFetchGsdbForLocationTypes = () => {
  const errorMessage = (locationTypeName: string): string =>
    `An error occurred when retrieving the ${locationTypeName} GSDBs`;

  const queries = [
    {
      queryKey: ["plantGsdbs"],
      staleTime: minutesAsMilliSeconds(10),
      cacheTime: minutesAsMilliSeconds(20),
      queryFn: async () =>
        fetchCollectionOf<SelectionListItem<string>>(plantUrls.selectableGsdbs.apiUrl),
      onError: () => toast.error(errorMessage("Plant")),
    },
    {
      queryKey: ["edcGsdbs"],
      staleTime: minutesAsMilliSeconds(10),
      cacheTime: minutesAsMilliSeconds(20),
      queryFn: async () => fetchCollectionOf<SelectionListItem<string>>(edcUrls.selectableGsdbs),
      onError: () => toast.error(errorMessage("EDC")),
    },
    {
      queryKey: ["odcGsdbs"],
      staleTime: minutesAsMilliSeconds(10),
      cacheTime: minutesAsMilliSeconds(20),
      queryFn: async () => fetchCollectionOf<SelectionListItem<string>>(odcUrls.selectableGsdbs),
      onError: () => toast.error(errorMessage("ODC")),
    },
    {
      queryKey: ["supplierGsdbs"],
      staleTime: minutesAsMilliSeconds(10),
      cacheTime: minutesAsMilliSeconds(20),
      queryFn: async () =>
        fetchCollectionOf<SelectionListItem<string>>(supplierUrls.selectableGsdbs.apiUrl),
      onError: () => toast.error(errorMessage("Supplier")),
    },
    {
      queryKey: ["branchGsdbs"],
      staleTime: minutesAsMilliSeconds(10),
      cacheTime: minutesAsMilliSeconds(20),
      queryFn: async () => fetchCollectionOf<SelectionListItem<string>>(branchUrls.selectableGsdbs),
      onError: () => toast.error(errorMessage("Carrier Branch")),
    },
  ];

  return useQueries<SelectionListItem<string>[]>([...queries]) as UseQueryResult<
    SelectionListItem<string>[]
  >[];
};

const fetchCollectionOf = async <T>(url: string) => {
  const { data } = await axios.get<T[]>(url);
  return data;
};
